<template>
  <div class="bg-light my-2">
    <div class="container m-auto position-relative ">
      <b-list-group>
        <b-list-group-item
          v-for="item in skills"
          :key="item.id"
          class="darker-hover border-0 d-flex justify-content-between align-items-center rounded shadow-sm my-1"
          :class="`${item.state && 'learned-skill'}`"
          @click="$parent.goModuleSkill(item.id, item.state)"
          style="cursor: pointer;"
        >
          <div class="d-flex align-items-center">
            <div class="mr-2" v-on:click.stop>
              <b-icon
                v-if="favoriteSkills && !favoriteSkills.includes(item.id)"
                icon="star"
                aria-hidden="true"
                class="star-uncheck"
                @click="() => addToFavorite(item.id)"
              ></b-icon>
              <b-icon
                v-if="favoriteSkills && favoriteSkills.includes(item.id)"
                icon="star-fill"
                aria-hidden="true"
                class="star-checked"
                @click="() => removeToFavorite(item.id)"
              ></b-icon>
            </div>
            <span class="m-0 text-darked">
              {{ item.text }}
            </span>
            <i v-if="item.state" class="material-icons align-middle text-darked smaller-icon ml-2">
              check
            </i>
          </div>
          <i class="material-icons align-middle text-muted">
            keyboard_arrow_right
          </i>
        </b-list-group-item>
      </b-list-group>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import store from '@/store';
export default {
  props: {
    skills: Array,
  },
  data() {
    return {
      favoriteSkills: [],
    };
  },
  computed: {
    ...mapGetters('parent', ['getFavoriteSkills']),
  },
  mounted() {
    // get parent favorite skills
    this.favoriteSkills = this.getFavoriteSkills || [];
  },
  methods: {
    ...mapActions('parent', ['setParentFavoriteSkills']),
    addToFavorite(id) {
      this.addFavoriteSkills(id);
    },
    removeToFavorite(id) {
      this.removeFavoriteSkills(id);
    },
    addFavoriteSkills(id) {
      this.setParentFavoriteSkills({
        userId: store.getters['user/getUserId'],
        favoriteSkill: [...(this.favoriteSkills ? this.favoriteSkills : []), id],
      }).then(() => {
        this.favoriteSkills = this.getFavoriteSkills;
      });
    },
    removeFavoriteSkills(id) {
      this.setParentFavoriteSkills({
        userId: store.getters['user/getUserId'],
        favoriteSkill: this.favoriteSkills
          ? this.favoriteSkills.filter((skill) => skill != id)
          : [],
      }).then(() => {
        this.favoriteSkills = this.getFavoriteSkills;
      });
    },
  },
};
</script>
<style lang="scss">
.smaller-icon {
  font-weight: bolder;
  font-size: 16px;
}
</style>

<style scoped>
.learned-skill {
  background-color: #e7f1e9;
}
</style>
